import { connect } from "react-redux";

import Table from "./Table";
import { getTableData } from "./tableActions";

const mapStateToProps = (state) => ({
  error: state.table.error,
  isLoading: state.table.isLoading,
  redirect: state.table.redirect || state.dashboard.redirect,
  tableData: state.table.data,
});

const mapDispatchToProps = (dispatch) => ({
  getTableData: (pagination) => dispatch(getTableData(pagination)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Table);
